import styled from '@emotion/styled';

const Container = styled('div')`
  display: grid;
  grid-template-columns: repeat(auto-fill, 136px);
  grid-gap: 2rem;
`;

export { Container };
